import React from 'react';
import CandidateEmail from '../CandidateEmail/CandidateEmail';
import { useState, useRef } from 'react';
import history from '../../routes/history';
import { candidateDetailSuccess } from '../../redux/actions';
import { useDispatch, useSelector } from "react-redux";
import ProgressBar from '../ProgressBar/ProgressBar';

const AddCandidateName = () => {
	const [loading, setLoading] = useState(false);
	const [nameValidation, setNameValidation] = useState('');
	const inputValue = useRef(null);
	const getInputValues = useSelector((state) => state.candidateReducer.candidateDetails);
	const dispatch = useDispatch();

	const clearValidation = () => {
		setNameValidation("");
	};

	const nextHandler = () => {
		const nameValue = inputValue.current.value.trim();
		const nameParts = nameValue.split(' ');
		if (!nameValue) {
			setNameValidation('Your name is required.');
			return;
		}
		if (nameParts.length < 2) {
			if (nameParts.length === 1) {
				setNameValidation('Your last name is required.');
			}
			return;
		}

		const [firstName, lastName] = nameParts;
		if (!firstName || !lastName) {
			setNameValidation('Both first name and last name are required.');
			return;
		}

		dispatch(candidateDetailSuccess({ ...getInputValues, name: nameValue }));
		history.push("/candidate-number");
	};

	const backHandler = () => {
		history.push('/add-candidate-email');
	};

	return (
		<CandidateEmail
			CandidateProgressBar={<ProgressBar percent={20} heading={'Create candidate’s profile'} />}
			CandidateText="Candidate’s name"
			placeholder="ex. Gary Smith"
			nextHandler={nextHandler}
			backHandler={backHandler}
			inputvalue={inputValue}
			loading={loading}
			types="name"
			validation={nameValidation}
			clearValidation={clearValidation}
			getInputValues={getInputValues?.name}
		/>
	);
};

export default AddCandidateName;

